var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInDevIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 36,
    viewBox: "0 0 38 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13442_117494)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.8516 18.2048L24.4184 14.399L28.2653 14.5377L33.8984 17.9856L24.5398 21.1234L22.8516 18.2048Z",
    fill: "#2E63DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.449526 16.6169L16.2104 12.4249L24.9945 6.90672L24.8913 1.20361C24.8791 0.505589 24.0955 0.0901503 23.5336 0.483638L0.450655 16.6186L0.449526 16.6169Z",
    fill: "#5F90FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1931 12.7046L0.449942 16.6168L23.4288 28.0887C24.0033 28.3757 24.6632 27.9597 24.6519 27.3178L24.5712 22.8986L24.4183 14.4017L16.1942 12.7063L16.1931 12.7046Z",
    fill: "#5F90FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9945 6.90675L33.8984 17.9856L24.4167 14.4001L0.449522 16.6169L24.9945 6.90675Z",
    fill: "#3E78FA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13442_117494"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.4468,
    height: 29.0293,
    fill: "white",
    transform: "matrix(-0.54879 -0.83596 -0.83596 0.54879 37.1348 19.6006)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInDevIcon);
export default __webpack_public_path__ + "static/media/in-dev-icon.bc8d5227680a3a93a52c314841e57941.svg";
export { ForwardRef as ReactComponent };